import React from 'react';
import {Link} from 'react-router-dom';

interface Props {
  followCount: number;
  showFinancialAidAwardLettersLink?: boolean;
}

const Header = ({followCount, showFinancialAidAwardLettersLink = false}: Props) => (
  <div className="college-earnings-header">
    <h1 className="shared-font body m-0">
      <span className="shared-font bold">College List</span>
      {Number.isInteger(followCount) && followCount > 0 && ` ${followCount}`}
    </h1>
    {showFinancialAidAwardLettersLink ? (
      <Link
        to="/portfolio/select-financial-aid-award-letter"
        data-segment-track="button"
        data-button-name="open award letter modal"
      >
        Your Award Letters
      </Link>
    ) : (
      <Link
        to="/colleges/my-list"
        data-segment-track="button"
        data-button-name="go to my list of colleges"
      >
        List Details
      </Link>
    )}
  </div>
);

export default Header;
